import { Helmet } from 'react-helmet-async';

export default function HelmetWrapper({ title, description, keywords }) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={`https://pingvite.in/`} />
        </Helmet>
    );
}